import { PageTypes } from "enums/pageTypes";
import { usePageType } from "hooks/usePageType";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PROJECT_TITLE } from "~app/constants";

export const HeaderLogo: React.FC = () => {
  const { customerId, sport, organizationId, entityId } = useParams();
  const [redirectLink, setRedirectLink] = useState("/");
  const pageType = usePageType();

  useEffect(() => {
    if (pageType === PageTypes.Admin && organizationId) {
      setRedirectLink(`/${sport}/${organizationId}/admin`);
      return;
    }

    if (pageType === PageTypes.TeamManager && entityId) {
      setRedirectLink(`/${customerId}/${sport}/${organizationId}/entities/${entityId}`);
      return;
    }

    setRedirectLink("/");
  }, [customerId, sport, organizationId, entityId, pageType]);

  return (
    <Link to={redirectLink} className="navbar-brand HeaderProjectBranding">
      <img className="HeaderProjectLogo" style={{ marginLeft: "-8px" }} src="/img/SR_logo_pos.png" alt="Logo" />
      <span className="HeaderProjectTitle">{PROJECT_TITLE}</span>
    </Link>
  );
};
